module.exports = __webpack_public_path__ + "static/img/3.AI审核_悬浮窗_image@2x.7c99c850.png";